import {groupBy} from "lodash/collection";

export default {
  operator: (feeds, status) => {
    return feeds.filter(item => status.includes(item.status));
  },
  manager: (feeds, status) => {
    let managerFeeds = feeds.filter(item => status.includes(item.status));
    return groupBy(managerFeeds, item => item.username);
  },
  admin: (feeds, status) => {
    let adminFeeds = feeds.filter(item => status.includes(item.status));
    return groupBy(adminFeeds, item => item.username);
  }
};
